import { render, staticRenderFns } from "./MobileTable.vue?vue&type=template&id=20d2f6dc&scoped=true&"
import script from "./MobileTable.vue?vue&type=script&lang=js&"
export * from "./MobileTable.vue?vue&type=script&lang=js&"
import style0 from "./MobileTable.vue?vue&type=style&index=0&id=20d2f6dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2f6dc",
  null
  
)

export default component.exports